declare module '@unity/cloud-ui/styles' {
  interface Theme {
    layout: {
      headerHeight: string;
      productHeaderHeight: string;
      sidebarDrawerMaxWidth: string;
    };
  }

  interface ThemeOptions {
    layout: {
      headerHeight: string;
      productHeaderHeight: string;
      sidebarDrawerMaxWidth: string;
    };
  }
}

export default {
  layout: {
    headerHeight: '48px',
    productHeaderHeight: '48px',
    fallbackLocaleBannerHeight: '48px',
    tocMaxWidth: '400px',
    sidebarDrawerMaxWidth: '320px',
    searchFilterContainerWidthMedium: '248px',
    searchFilterContainerWidthSmall: '184px',
    pageContentSpacing: 3,
  },
  zoom: {
    dense: '95%',
    normal: '100%',
    comfortable: '110%',
  },
  cssVariables: {
    fallbackBannerHeight: '--fallback-banner-height',
  },
};
